import a, { forwardRef as u } from "react";
import l from "./index.es437.js";
function c() {
  return c = Object.assign || function(r) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (r[t] = e[t]);
    }
    return r;
  }, c.apply(this, arguments);
}
function h(r, o) {
  if (r == null) return {};
  var e = p(r, o), t, n;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(r);
    for (n = 0; n < i.length; n++)
      t = i[n], !(o.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(r, t) && (e[t] = r[t]);
  }
  return e;
}
function p(r, o) {
  if (r == null) return {};
  var e = {}, t = Object.keys(r), n, i;
  for (i = 0; i < t.length; i++)
    n = t[i], !(o.indexOf(n) >= 0) && (e[n] = r[n]);
  return e;
}
var s = u(function(r, o) {
  var e = r.color, t = e === void 0 ? "currentColor" : e, n = r.size, i = n === void 0 ? 24 : n, f = h(r, ["color", "size"]);
  return /* @__PURE__ */ a.createElement("svg", c({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, f), /* @__PURE__ */ a.createElement("rect", {
    x: "3",
    y: "3",
    width: "7",
    height: "7"
  }), /* @__PURE__ */ a.createElement("rect", {
    x: "14",
    y: "3",
    width: "7",
    height: "7"
  }), /* @__PURE__ */ a.createElement("rect", {
    x: "14",
    y: "14",
    width: "7",
    height: "7"
  }), /* @__PURE__ */ a.createElement("rect", {
    x: "3",
    y: "14",
    width: "7",
    height: "7"
  }));
});
s.propTypes = {
  color: l.string,
  size: l.oneOfType([l.string, l.number])
};
s.displayName = "Grid";
export {
  s as default
};
//# sourceMappingURL=index.es366.js.map
